import React from 'react';
import UtilityHeader from '@common/components/app-layout/utility-header/utility-header';
import UtilityBar from './utility-bar';

const AwareUtilityHeader = ({ title, children, select, hideBreadcrumbs }) => {
  return (
    <UtilityHeader
      title={title}
      select={select}
      hideBreadcrumbs={hideBreadcrumbs}
      UtilityBar={UtilityBar}
    >
      {children}
    </UtilityHeader>
  );
};

export default AwareUtilityHeader;
